import React from 'react'
import { useNavigate } from 'react-router-dom'

export function useModal(initialState: boolean): [boolean, () => void, () => void, (url:any)=> void] {
    const [show, setShow] = React.useState(initialState)
    const navigate = useNavigate()
    const open = () => setShow(true)
    const close = () => setShow(false)
    const closeWithRoute = (url:any)=>{
        setShow(false);
        navigate(url)
    }

    return [show, open, close,closeWithRoute]
}
export default useModal
